import { Hero } from "@/components/hero"
import { TemporaryHoursBanner } from "@/components/temporary-hours-banner"
import { About } from "@/components/about"
import { FlavorsPreview } from "@/components/flavors-preview"
import { Faq } from "@/components/faq"
import { Footer } from "@/components/footer"
import { useSeo } from "@/hooks/use-seo"

export function HomePage() {
  useSeo({
    title: "Vape Shop Częstochowa – #Zielarz | Liquidy, Sole, Longfille",
    description:
      "Vape Shop w Częstochowie – #Zielarz. Największy wybór liquidów, soli nikotynowych, longfilli i akcesoriów do e-papierosów. Sklep vape przy alei Wolności 17 (centrum). Doradztwo, świetne ceny – zapraszamy!",
    path: "/",
  })

  return (
    <>
      <Hero />
      <TemporaryHoursBanner />
      <About />
      <FlavorsPreview />
      <Faq />
      <Footer />
    </>
  )
}
